export default "__VITE_ASSET__ea29c43b__"